import { Language } from './language.enum';

export const LANGUAGES = [Language.EN_US, Language.ES_ES, Language.FR_FR, Language.PT_BR];
